import AccountInventoryService from '@/services/accountinventory.service.js'
import awsAcctService from '@/services/awsacct.service.js'
import changeLogService from '@/services/changelog.service.js'
import OppregAdminService from '@/services/oppregadmin.service'

export default {
  getAllMasterPayer: context=>{
    awsAcctService.getAllMasterPayer((res,err) => {
      if(err){
      } else {
        context.commit('setMasterPayer', res)
      }
    })
  },
  getAllObEngineers: context =>  {
    awsAcctService.getAllObEngineers((res,err) => {
      if(err){

      } else {
        context.commit('setObEngineers', res)
      }
    })
  }, 

  createEngineer: (context,data) => {
    awsAcctService.checkIfEngineerIsAvailable(data, (res,err) => {
      if(err) {
      } else{
        if(res.data.length > 0){
          let errMsg = 'Data already exists!'
          context.commit('showEngrResponseMsg', errMsg)
        } else {
          awsAcctService.createEngineer(data,(res, err) => {
            if(err){

            } else {
              let concatNameEmail = data.Name+' - '+data.Email
              console.log('Concat Name Email: ', concatNameEmail)
              let newRecord = {
                Id: res.data.id , 
                Name: data.Name,
                Email: data.Email, 
                Name_Email: concatNameEmail
                
              }
              context.commit('updateObEngrsRecord', newRecord)
              context.commit('showEngrResponseMsg', res.data.response)
              context.commit('resetCreateEngrData')
            }
          })
        }
      }
    })
  
  },
  sendEngrEmail: (context, data) => {
    awsAcctService.sendEngrEmail(data,(res,err)=> {
      if(err){ 
      } else {
        context.commit('showDialog', {
          type: 'alert',
          title: 'Email has been sent!',
          show: true
        },
        { root: true })
          
      }
    }) 
  },
  getAllOnboardingRequests: async function (context, params) {
    console.log('Fetching all onboarding requests', params)
    context.commit('setLoadingRequest', true)
    if (!params.nextPaginationKey) {
      context.commit('setViewRequestsData', [])
    }
    return new Promise((resolve, reject) => {
      awsAcctService.getAllOnboardingRequests(params, (res, err) => {
        console.log('Response from getAllOnboardingRequests: ', res)
        if (err) {
          context.commit('setLoadingRequest', false)
          reject(err)
        } else {
          context.commit('setLoadingRequest', false)
          context.commit('setViewRequestsData', res.data)
          context.commit('setNextPaginationKey', res.nextPaginationKey)
          resolve(res)
        }
      })
    })
  },
  downloadAllOnboardingRequests: async function (context, params) {
    context.commit('setDownloadingAccount', true)
    return new Promise((resolve, reject) => {
      awsAcctService.downloadAllOnboardingRequests(params, (res, err) => {
        if (err) {
          reject(err)
        } else {
          window.open(res, '_blank').focus()
          context.commit('setDownloadingAccount', false)
          resolve(res)
        }
      })
    })
  },
  checkIfAccountIdIsAvailable: (context, id) => {
    if (id.length > 12) {
      context.commit('setAccountIdAvailabilityMessage', { type: 'error', isExist:true, message: 'Account Id should only contain 12 digits' })
    } else {
      context.commit('setAccountIdExistLoading', true)
      AccountInventoryService.checkIfAccountIdIsAvailable(id, (res, err) => {
        if (err.acctExist) {          
            let existingOnboardingRecord = {
              AcctSecurity_Id: err.data[0].AcctSecurity_Id, 
              Acct_Exp_Id: err.data[0].Acct_Exp_Id, 
              Acct_ID: err.data[0].Acct_ID, 
              Financial_Id: err.data[0].Financial_Id, 
              Onboarding_Id: err.data[0].Onboarding_Id, 
              Unique_Agreement_Id: err.data[0].Unique_Agreement_Id,
              Onboarding_Status: err.data[0].Onboarding_Status
            }
          context.commit('setAccountIdAvailabilityMessage', { type: 'error', isExist:true, message: 'This Acct ID has already been registered.', record: err.data[0] })
          context.commit('setChangeLogRecord',{ id:err.data[0].Onboarding_Id, changeFrom:existingOnboardingRecord }, { root: true })
         } 
        else {
          context.commit('setAccountIdAvailabilityMessage', { type: 'success', isExist:false, message: 'This Acct ID is available to use.'})
        }
        context.commit('setAccountIdExistLoading', false)
      })
    }
  },

  // checkIfOpportunityNumberIsAvailable: (context, id) => {
    
  //   context.commit('setOpportunityNumberExistLoading', true)
  //   console.log('Opportunity Number: ' + id)
  //   if ((id === null) || (id === '') || (id.toLowerCase() === 'none')) {
  //     context.commit('setOpportunityNumberExistLoading', false)
  //   } else {
  //     AccountInventoryService.checkIfOpportunityNumberIsAvailable(id, (res, err) => {
  //       if (err.opportunityNumberExist) {          
  //         context.commit('setOpportunityNumberAvailabilityMessage', { type: 'error', isExist:true, message: 'This Opportunity Number has already been registered.', record: err.data[0] })
  //       } else {
  //         context.commit('setOpportunityNumberAvailabilityMessage', { type: 'success', isExist:false, message: 'This Opportunity Number is available to use.'})
  //       }
  //       context.commit('setOpportunityNumberExistLoading', false)
  //     })
  //   }
  // },

  

  
 
  updateWorkflow: (context, record) => {
    context.commit('setLoadingUpdate', true)
    awsAcctService.updateOnboardingAccount(record, (res, err) => {
      
      if (err) {
        context.commit('setAlertMessage', { alertType: 'error', alertMessage: 'Error updating record' })
      } else {
            let onboardingRecord = {
              AWS_Req_Type: record.AWS_Req_Type,
              AWS_credits: record.AWS_credits,
              Account_Owners: record.Account_Owners,
              AcctSecurity_Id: record.AcctSecurity_Id,
              Acct_Alias_Group: record.Acct_Alias_Group,
              Acct_DL: record.Acct_DL,
              Acct_Description: record.Acct_Description,
              Acct_Exp_Id: record.Acct_Exp_Id,
              Acct_ID: record.Acct_ID,
              Acct_Restricted: record.Acct_Restricted,
              Acct_name: record.Acct_name,
              Business_Use: record.Business_Use,
              Calculated_Master_Payer: record.Calculated_Master_Payer,
              // CloudCheckr_users: record.CloudCheckr_users,
              Customer_Id: record.Customer_Id,
              Customer_Name: record.Customer_Name,
              Date_Requested: record.Date_Requested,
              Date_onboarded: record.Date_onboarded,
              Engr_Assigned_To: record.Engr_Assigned_To,
              Financial_Id: record.Financial_Id,
              Financial_Owner: record.Financial_Owner.replace(/[ "/+?^${}()|[\]\\]/g,''),
              IAM_Users: record.IAM_Users.replace(/[ "/+?^${}()|[\]\\]/g,''),
              IWO_Code: record.IWO_Code,
              MFA: record.MFA,
              MP_ID: record.MP_ID,
              Managed_Svc: record.Managed_Svc,
              Notification_List: record.Notification_List.replace(/["/+?^${}()|[\]\\]/g,''),
              OBS_Date_Updated: record.OBS_Date_Updated,
              Onboarding_Id: record.Onboarding_Id,
              Onboarding_Status: record.Onboarding_Status,
              OppReg_Id: record.OppReg_Id,
              // Opportunity_Number: record.Opportunity_Number,
              Registration_Id: record.Registration_Id,
              Request_Type: record.Request_Type,
              Requestor_FullName: record.Requestor_FullName,
              Root_Credential_Store: record.Root_Credential_Store,
              SaaS: record.SaaS,
              Specific_Location: record.Specific_Location,
              Specific_Region: record.Specific_Region,
              Tmp_Cust_Name: record.Tmp_Cust_Name,
              Unique_Agreement_Id: record.Unique_Agreement_Id,
              WBS_code: record.WBS_code,
              GovCloud_Resource_Account: record.GovCloud_Resource_Account
            }
        context.commit('setChangeLogRecord', { id: record.Onboarding_Id, changeTo: onboardingRecord }, { root: true })
        // context.commit('setChangeLogRecord', { id: record.Onboarding_Id, changeTo: record }, { root: true })
        changeLogService.create(context.rootState.logRecord)
        context.commit('setLoadingUpdate', false)
            
        context.commit('updateOnboardingRecordList', record)

        context.commit('setAlertMessage', { alertType: 'success', alertMessage: 'Successfully updated record' })
        document.querySelector('#update-dialog-content').scrollTop = 0
      }
    })
  },
  updateExistingAcctId: (context, record) => {

    awsAcctService.updateExistingAcctId(record, (res, err) => {
      if(err){

      } else {
        console.log('------ actionnnn:updateExistingAcctID ------')
        console.log(record.data)
        console.log('----------------------------------')
        let existingOnboardingRecord = {
          AcctSecurity_Id: record.data.AcctSecurity_Id, 
          Acct_Exp_Id: record.data.Acct_Exp_Id, 
          Acct_ID: record.accountId, 
          Financial_Id: record.data.Financial_Id, 
          Onboarding_Id: record.data.Onboarding_Id, 
          Unique_Agreement_Id: record.data.Unique_Agreement_Id,
          Onboarding_Status: record.data.Onboarding_Status
        }
        context.commit('setChangeLogRecord',{ id:record.data.Onboarding_Id, changeTo:existingOnboardingRecord }, { root: true })
        console.log('----------------- record.data ----------------')
        console.log(context.rootState.logRecord)
        console.log('-----------------------------------------------')
        changeLogService.create(context.rootState.logRecord)
        record.data.Acct_ID = record.accountId
        context.commit('updateOnboardingRecordList', record.data)
        context.commit('setAccountIdAvailabilityMessage', {type:'success', isExist:false, message: 'This Acct Id is available to use'})
        

        //record.showData.record.Acct_ID = record.showData.acctId

        let notify = JSON.parse(record.showData.record.Notification_List)
        let notifyy = JSON.stringify(notify.map(record => record)) 
        let iamuser = JSON.parse(record.showData.record.IAM_Users)
        let iamuserr = JSON.stringify(iamuser.map(record => record)) 
        let finance = JSON.parse(record.showData.record.Financial_Owner)
        let financee = JSON.stringify(finance.map(record => record)) 

        let openRecord =  {
          Onboarding_Id: record.showData.record.Onboarding_Id,
          Acct_name: record.showData.record.Acct_name,
          Acct_Description: record.showData.record.Acct_Description,
          Requestor_FullName: record.showData.record.Requestor_FullName,
          Date_Requested: record.showData.record.Date_Requested,
          Managed_Svc: record.showData.record.Managed_Svc,
          Calculated_Master_Payer: record.showData.record.Calculated_Master_Payer,
          Acct_DL: record.showData.record.Acct_DL,
          Acct_ID: record.showData.acctId,
          Acct_Alias_Group: record.showData.record.Acct_Alias_Group,
          Onboarding_Status: record.showData.record.Onboarding_Status,
          Date_onboarded: record.showData.record.Date_onboarded,
          Acct_Restricted: record.showData.record.Acct_Restricted,
          Business_Use: record.showData.record.Business_Use,
          Customer_Id: record.showData.record.Customer_Id,
          Customer_Name: record.showData.record.Customer_Name,
          Financial_Id: record.showData.record.Financial_Id,
          Aws_credits: record.showData.record.Aws_credits,
          WBS_code: record.showData.record.WBS_code,
          IWO_code: record.showData.record.IWO_code,
          Request_Type: record.showData.record.Request_Type,
          Saas: record.showData.record.SaaS,
          MFA: record.showData.record.MFA,
          Root_Credential_Store: record.showData.record.Root_Credential_Store,
          Specific_Location: record.showData.record.Specific_Location,
          Specific_Region: record.showData.record.Specific_Region,
          Tmp_Cust_Name: record.showData.record.Tmp_Cust_Name,
          AWS_Req_Type: record.showData.record.AWS_Req_Type,
          AWS_Support_Type: record.showData.record.AWS_Support_Type,
          Master_Id:record.showData.record.Master_Id,
          MP_ID: record.showData.record.MP_ID,
          AcctSecurity_Id: record.showData.record.AcctSecurity_Id, 
          Unique_Agreement_Id: record.showData.record.Unique_Agreement_Id, 
          Acct_Exp_ID: record.showData.record.Acct_Exp_ID,
          Registration_Id: record.showData.record.Registration_Id, 
          Account_Owners: record.showData.record.Account_Owners,
          IAM_Users: iamuserr.replace(/[ "/+?^${}()|[\]\\]/g,''),
          Notification_List: notifyy.replace(/[ "/+?^${}()|[\]\\]/g,''),
          Financial_Owner: financee.replace(/[ "/+?^${}()|[\]\\]/g,''),
          Invoice_DL: record.showData.record.Invoice_DL,
          GovCloud_Resource_Account: record.showData.record.GovCloud_Resource_Account
        }
        console.log('------------action: updateExistingAcctId----------')
        console.log(openRecord)
        console.log('------------------------------------------')
        context.commit('setChangeLogRecord',{ id:record.showData.record.Onboarding_Id, changeFrom:openRecord}, { root: true })

      }
    })
  },


  getOnboardingLogs: (context, id) => {
    context.commit('setLoadingOnboardingLogs', true)
    changeLogService.getById(id, (res, err) => {
      if (err) {

      } else {
        context.commit('setLoadingOnboardingLogs', false)
        context.commit('setOnboardingChangeLog', res)
      }
    })
  },

  downloadDocument: (context, filename) => {
    OppregAdminService.downloadDocument(filename, res => {
      window.open(res, '_blank')
    })
  },


  createAccount: (context, account) => {
    context.commit('setCreateAccountLoading', true)

    awsAcctService.createAccount(account, (res, err) => {
      if (err) {
        context.commit('setAlertMessage', { alertType: 'error', alertMessage: err })
      } else {
        // set the account id and the status
        context.commit('setDeliveredAccount', res)
        context.commit('setAlertMessage', { alertType: 'success', alertMessage: 'Successfully created AWS Account' })
        console.log(res)
        context.commit('updateOnboardingRecordList', { ...account, Acct_ID: res, Onboarding_Status: 'Account Configuration in Progress' })
      }
      context.commit('resetCreateAccount')
    })
  }
}